import React from "react";
import { FormattedMessage } from "react-intl";

import { IProps } from "./interfaces";

const PackName = ({ pack }: IProps) => {
    if (pack.name === "{start_pack}") return <FormattedMessage id={"pack.start"} />;
    else return <>{pack.name}</>;
};

export default PackName;
